import { $ } from '@starberry/components';

export default {
  $: 'Stack',

  props: {
    bgColor: $('constants.sidebarBgColor'),
    display: { base: 'none', lg: 'flex' },
    direction: 'column',
    color: 'white',
    width: '340px',
    zIndex: 999,
    position: 'sticky',
    height: '100vh',
    top: 0,
    left: 0,
    bottom: 0,
    py: [8, 8, 10],
    align: 'center',
    overflow: 'auto',
  },

  logoContainerProps: {
    mb: [4, null, 16],
    w: ['45px', null, '75px', '90px'],
    h: 'auto',
  },

  logoContainer: (props) => {
    return {
      $: 'Box',
      props: props.logoContainerProps,
      children: {
        component: props.companyLogo,
        props: {
          id: 'desktopLogo',
        },
      },
    };
  },

  children: ({ logoContainer, sideNav }) => {
    return [
      { $: logoContainer },
      {
        $: 'SideMenu',
        children: sideNav.map(({ visibility, ...item }) => {
          return {
            ...item,
            props: {
              ...item.props,
              display: visibility?.desktop ? 'flex' : 'none',
            },
          };
        }),
      },
    ];
  },
};
